/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useRef } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import { useApiRequestState } from '../../../../../../../../utils/api.utils';
import useOutsideClick from '../../../../../../../../utils/click.utils';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';

import { LabelMenu } from '../../TaskMenus/LabelMenu';
import { IMenuLabelsProps } from './types';

export const MenuLabels: FunctionComponent<IMenuLabelsProps> = ({ taskId }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskLabels1');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskLabels1'));
    }
  }, [dispatch, open]);
  const handleClickOutside = () => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    }
  };

  useOutsideClick({
    callback: handleClickOutside,
    refs: [menuRef, triggerRef],
    enabled: open,
  });
  const [showLoader] = useApiRequestState('updateTaskApi');
  return (
    <div
      className={open ? 'dropdown opened' : 'dropdown'}
      style={showLoader ? { pointerEvents: 'none' } : {}}
      ref={menuRef}
    >
      <a
        className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 dropdown-button "
        onClick={toggle}
        ref={triggerRef}
      >
        <img
          src={require('../../../../../../../../components/resources/images/labels-icon.png')}
          className="mr-1"
          alt="img"
        />
        Labels
      </a>
      {open && <LabelMenu dropRight={true} closeMenu={toggle} taskId={taskId} triggerRef={triggerRef} />}
    </div>
  );
};
